import React, { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  DefaultLegendContent,
} from 'recharts';
import '../../styles/dashboardPagesStyle/CardVGV.css';
import { Info } from 'lucide-react';
import { getVGVUltimos12Meses, VGVResponseItem } from "../../API/dashboardPageService";

const CardVGV: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getVGVUltimos12Meses();

        // mapeia para o formato do gráfico
        const formatted = response.map((item: VGVResponseItem) => ({
          mes: item.mes,
          VGV: item.vgv,
          Projeção: item.valor_medio, // aqui você decide: usa "valor_medio" como projeção?
        }));

        setData(formatted);
      } catch (error) {
        console.error("Erro ao carregar VGV", error);
      }
    }

    fetchData();
  }, []);

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: 'Este gráfico exibe o VGV mensal e a projeção para cada mês, permitindo acompanhar a evolução financeira.',
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  const renderCustomLegend = (props: any) => {
    if (!props.payload) return null;
    const ordem = ["VGV", "Projeção"];
    const itensOrdenados = [...props.payload].sort(
      (a, b) => ordem.indexOf(a.value) - ordem.indexOf(b.value)
    );

    return (
      <DefaultLegendContent
        {...props}
        payload={itensOrdenados.map((entry) => ({
          ...entry,
          value: <span style={{ color: entry.color }}>{entry.value}</span>,
        }))}
      />
    );
  };

  return (
    <div className="card-vgv info-card">
      <div className="card-vgv-header">
        <h3 className="card-vgv-title">VGV mensal</h3>
        <Info className="info-btn" size={20} onClick={handleInfoClick} />
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <XAxis dataKey="mes" style={{ fontSize: '11px' }} />
          <YAxis
            style={{ fontSize: '11px' }}
            tickFormatter={(value) => `R$ ${(value / 1_000_000).toFixed(1)}M`}
          />
          <Tooltip formatter={(value: number) => `R$ ${(value / 1_000_000).toFixed(2)}M`} />
          <Legend
            verticalAlign="bottom"
            align="center"
            content={renderCustomLegend}
            wrapperStyle={{ marginTop: -6 }}
          />

          <Line
            type="monotone"
            dataKey="VGV"
            stroke="#29306A"
            strokeWidth={2}
            dot={{ r: 3, stroke: '#29306A', strokeWidth: 1, fill: '#fff' }}
            activeDot={{ r: 5 }}
          />

          <Line
            type="monotone"
            dataKey="Projeção"
            stroke="#32BEF0"
            strokeWidth={2}
            strokeDasharray="3 1"
            dot={{ r: 3, stroke: '#32BEF0', strokeWidth: 1, fill: '#fff' }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardVGV;
